import clsx from 'clsx';
import map from 'lodash/map';
import Link from 'next/link';
import React from 'react';
import styles from './Auth.module.scss';

const tabs = Object.freeze({
    login: {
        title: 'Вход',
    },
    registration: {
        title: 'Регистрация',
    },
});

export type Tab = keyof typeof tabs;

export type AuthProps = {
    activeTab: Tab;
};

export const Auth: React.FC<AuthProps> = ({ activeTab, children }) => {
    return (
        <div className={styles.container}>
            <div className={styles.inner}>
                <div className={styles.tabs}>
                    {map(tabs, ({ title }, name: Tab) => (
                        <Link key={name} href={`/auth/${name}`}>
                            <a
                                className={clsx(
                                    styles.tabItem,
                                    activeTab === name && styles.active
                                )}
                            >
                                {title}
                            </a>
                        </Link>
                    ))}
                </div>
                <div>{children}</div>
            </div>
        </div>
    );
};
